import { ProviderRegistrationGenderDisclosureInner, ProviderRegistrationGenderDisclosureInnerTypeEnum } from "@asd/customer-portal-api";
import { Box, Checkbox, FormControlLabel, Stack } from "@mui/material";

import { GENDER_OPTIONS } from "~/utils/providerRegistrationHelpers";
import CheckboxWithText from "./shared/CheckboxWithText";
import FieldError from "./shared/FieldError";
import useExclusiveOption from "./shared/useExclusiveOption";

interface GenderDisclosureEditProps {
  value: ProviderRegistrationGenderDisclosureInner[];
  onChange: (_val: ProviderRegistrationGenderDisclosureInner[]) => void;
  error?: string;
}

const GenderDisclosureEdit = ({ value = [], onChange, error }: GenderDisclosureEditProps) => {
  const declineKey = ProviderRegistrationGenderDisclosureInnerTypeEnum.no_answer;
  const { isExclusiveSelected: isDeclineSelected, isAnyNonExclusiveSelected: isAnyNonDeclineSelected } = useExclusiveOption(
    value.map((v) => v.type),
    declineKey,
  );

  return (
    <Stack direction="column">
      {GENDER_OPTIONS.map(([enumValue, label]) => {
        const existing = value.find((v) => v.type === enumValue);
        const isThisDecline = enumValue === declineKey;
        const isSelfDescribed = enumValue === ProviderRegistrationGenderDisclosureInnerTypeEnum.self_described;
        const isDisabled = (isDeclineSelected && !isThisDecline) || (isAnyNonDeclineSelected && isThisDecline);
        const isTextActive = typeof existing?.selfDescription === "string";

        if (isSelfDescribed) {
          return (
            <Box key={enumValue} sx={{ gridColumn: "span 2" }}>
              <CheckboxWithText
                checked={!!existing || isTextActive}
                disabled={isDisabled}
                error={error}
                isTextActive={isTextActive}
                label=""
                onCheckChange={(checked) => {
                  if (!checked) {
                    onChange(value.filter((v) => v.type !== enumValue));
                  } else {
                    onChange([...value, { type: enumValue, selfDescription: "" }]);
                  }
                }}
                onTextChange={(text) => {
                  onChange(value.map((v) => (v.type === enumValue ? { ...v, selfDescription: text } : v)));
                }}
                textLabel="Prefer to self-describe"
                textValue={existing?.selfDescription ?? ""}
              />
            </Box>
          );
        }

        return (
          <FormControlLabel
            key={enumValue}
            control={
              <Checkbox
                checked={!!existing}
                disabled={isDisabled}
                onChange={(e) => {
                  if (!e.target.checked) {
                    onChange(value.filter((v) => v.type !== enumValue));
                  } else {
                    onChange([...value, { type: enumValue }]);
                  }
                }}
              />
            }
            label={label}
          />
        );
      })}
      <FieldError error={error} show={!value?.length} />
    </Stack>
  );
};

export default GenderDisclosureEdit;
